import { render, staticRenderFns } from "./FooterSaveCancel.vue?vue&type=template&id=0fdeb538"
import script from "./FooterSaveCancel.vue?vue&type=script&lang=js"
export * from "./FooterSaveCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports